import { Link, useLocation } from "react-router-dom";
import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import { getAllStaff } from "../../../services";
import React, { useEffect, useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as sweetalert from "sweetalert";
import ConfirmDialog from "../global/ConfirmDialog";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const initialRows = [
  {
    id: 1,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
  {
    id: 2,
    Trip: "Jon Snow",
    Startdate: "jonsnow@gmail.com",
    image: 35,
    city: "New York",
    Area: "New York",
    Comping: "10001",
    Level: 123512,
    Marshall: 123512,
  },
];
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <Box className="div-btn-header">
          <Button
            component={Link}
            variant="contained"
            className="btn-submit"
            color="secondary"
            to="/create-staff"
          >
            اضافة مستخدم
          </Button>
        </Box>
      </GridToolbarContainer>

      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "طلبات المستخدمين",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Staff = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
      // Save the current path to local storage whenever it changes
      localStorage.setItem('lastPath', location.pathname);
  }, [location]);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState(initialRows);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  useEffect(() => {
    getAllStaff()
      .then((res) => {
        setUsers(res.data);

        setIsLoading(true);
      })
      .catch((err) => {
        setUsers([]);
        setIsLoading(false);
      });

    return () => {};
  }, []);

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };
  const handleDeleteClick = (id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    axios
      .delete(
        `${BaseUrl}/api/staff/${id}`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.status === 200) {
          sweetalert(res.data.message, {
            className: "alert-div",
            button: {
              text: "تم",
            },
          }).then(() => {
            setUsers(users.filter((row) => row.id !== id));
          })
        } else {
          sweetalert("هذا المستخدم غير موجود", {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      })
      .catch((err) => {});
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };
  const handleView = (id) => () => {
    navigate(`/viewstaff/${id}`, { state: { id: id } });
  };
  const columns = [
    {
      field: "first_name",
      headerName: "الاسم",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "father_name",
      headerName: "اسم الأب",
      headerAlign: "center",
      align: "center",
      flex: 1,

      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "mother_name",
      headerName: "اسم الأم",
      headerAlign: "center",
      align: "center",
      flex: 1,

      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "last_name",
      headerName: "الكنية",
      headerAlign: "center",
      align: "center",
      flex: 1,

      editable: false,
    },
    {
      field: "mobile_number",
      headerName: "رقم الموبايل",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,

      editable: false,
    },
    {
      field: "provider_id",
      headerName: " نفطة البيع syrialtel",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      width: 250,
      minWidth: 150,
      maxWidth: 300,
      editable: false,
      valueGetter: (params) => {
        return params.row.provider_id ? params.row.provider_id?.gsm : "";
      },
    },
    {
      field: "distributor_id",
      headerName: " نفطة البيع MTN",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      width: 250,
      minWidth: 150,
      maxWidth: 300,
      editable: false,
      valueGetter: (params) => {
        return params.row.distributor_id
          ? params.row.distributor_id?.DealerCode
          : "";
      },
    },
    {
      field: "fund",
      headerName: "الرصيد الحالي",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,

      editable: false,
    },
    {
      field: "city_id",
      headerName: "المدينة",
      headerAlign: "center",
      align: "center",
      flex: 1,

      editable: false,
      valueGetter: (params) => {
        return params.row.city_id?.name_ar;
      },
    },
    {
      field: "zone_id",
      headerName: "المنطقة",
      headerAlign: "center",
      align: "center",

      flex: 1,
      editable: false,
      valueGetter: (params) => {
        return params.row.zone_id?.name;
      },
    },
    {
      field: "staff_type",
      headerName: "نوع الزبون",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      valueGetter: (params) => {
        const staff_type = params.value 
        return staff_type === "GeneralDistributor"
          ? 'موزع عام'
          : staff_type === "SpecialDistributor" ?"موزع خاص":staff_type === "Admin" ? "أدمن":"زبون"
      },
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      flex: 3,
      cellClassName: "actions",
      renderCell: ({ id }) => {
        return (
          <Box>
            <Button
              variant="contained"
              color="primary"
              className="viewbtn"
              onClick={handleView(id)}
            >
              استعراض
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="activationbtn3"
              onClick={() => {
                setConfirmDialog({
                  isOpen: true,
                  title: "هل تريد حذف هذه السجل؟",
                  subTitle: "لايمكن التراجع عن هذه العملية",
                  onConfirm: () => {
                    handleDeleteClick(id);
                  },
                });
              }}
            >
              حذف
              <img
                src="deleteicon.svg"
                className="icondelete"
                alt="delete icon"
              ></img>
            </Button>
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
            ,
          </Box>
        );
      },
    },
  ];
  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      {isLoading ? (
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.redAccent[1100],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.redAccent[1100],
              borderBottom: "none",
              fontSize: "10px !important",
            },
            "& .MuiDataGrid-cellContent": {
              fontSize: "10px !important",
              color: `${colors.grey[600]} !important`,
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.white[100],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.redAccent[1100],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
          }}
        >
          <DataGridPro
            rows={users}
            className="field-table"
            columns={columns}
            editMode="row"
            pageSize={10}
            pagination
            rowModesModel={rowModesModel}
            onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
            onRowEditStart={handleRowEditStart}
            onRowEditStop={handleRowEditStop}
            processRowUpdate={processRowUpdate}
            components={{
              Toolbar: EditToolbar,
            }}
            localeText={{
          toolbarColumns: "الأعمدة",
          toolbarFilters: "الفلاتر",
          toolbarDensity: "التباعد",
          toolbarExport: "تصدير",
          filterPanelAddFilter:'إضافة فلتر',
          filterOperatorContains:'تحتوي',
          filterOperatorEquals:'تساوي',
          filterOperatorStartsWith:'تبدأ ب',
          filterOperatorEndsWith:'تنتهي  ب',
          filterOperatorIsAnyOf:'هو أي من',
          filterOperatorIsEmpty:'فارغ',
          filterOperatorIsNotEmpty:'غير فارغ',
          toolbarDensityCompact:'دمج',
          toolbarDensityStandard:'معيار',
          toolbarDensityComfortable:'مريح',
          toolbarExportCSV:'تصدير CSV',
          toolbarExportPrint:'طباعة',
          filterPanelInputLabel:'القيمة',
          filterPanelInputPlaceholder:"ادخل القيمة",
          filterPanelColumns:'الاعمدة',
          filterPanelOperators:'العمليات',
          columnsPanelTextFieldLabel:'بحث عن عمود',
          columnsPanelTextFieldPlaceholder:'عنوان العمود',
                  }}
            componentsProps={{
              toolbar: { setRows, setRowModesModel },
            }}
            experimentalFeatures={{ newEditingApi: true }}
          />
        </Box>
      ) : (
        <img src="loading.svg" alt="load" class="load" />
      )}
    </Box>
  );
};

export default Staff;
